import { getArchivedChats } from './getArchivedChats';
import { getLastTimeStamp } from '../../reducers/chatList/helpers';
import { TThunkAction } from '../../types/redux/thunk';

export const getArchivedListNextPage = (): TThunkAction<void> => (dispatch, getState) => {
  const state = getState();
  const { chatList } = state;

  const timestampArchive = chatList.chats.length ? getLastTimeStamp(chatList.chats) : state.chatList.timestampArchive;

  dispatch(getArchivedChats({ timestampArchive }));
};
